// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"camera_backdrop__MVrdL","close":"camera_close__3DIiX","wrapper":"camera_wrapper__3op00","video":"camera_video__1dq9Z","button":"camera_button__XTFWf"};